/**
 * @flow
 * @relayHash dacf424cae9bf056cf04f1c472e0fd9d
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ProfileChangePasswordQueryVariables = {||};
export type ProfileChangePasswordQueryResponse = {|
  +me: ?{|
    +id: string,
    +username: string,
    +isAuthenticated: ?boolean,
  |}
|};
export type ProfileChangePasswordQuery = {|
  variables: ProfileChangePasswordQueryVariables,
  response: ProfileChangePasswordQueryResponse,
|};
*/


/*
query ProfileChangePasswordQuery {
  me {
    id
    username
    isAuthenticated
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "me",
    "storageKey": null,
    "args": null,
    "concreteType": "User",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "username",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "isAuthenticated",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ProfileChangePasswordQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": (v0/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "ProfileChangePasswordQuery",
    "argumentDefinitions": [],
    "selections": (v0/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "ProfileChangePasswordQuery",
    "id": null,
    "text": "query ProfileChangePasswordQuery {\n  me {\n    id\n    username\n    isAuthenticated\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'fdd91b7cd686cfd6c3b3078591e3aff2';
module.exports = node;
